import '../App.css';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { faDeleteLeft } from '@fortawesome/free-solid-svg-icons';
import * as Cases from '../slices/casesSlice';

const SearchCases = () => {
	const dispatch = useAppDispatch();
	const casesState = useAppSelector(state => state.cases);

	return (
		<div style={{ display: 'flex', padding: 4, alignItems: 'center' }}>
			<div className="padding8">
				<FontAwesomeIcon icon={faMagnifyingGlass} />
			</div>
			<div className="flexGrow1">
				<input className="OrangeOnWhite" type="text" value={casesState.searchStr} onChange={e => dispatch(Cases.searchCases({ searchStr: e.target.value, isWishlisted: false }))} />
			</div>
			<div className="padding8">
				<FontAwesomeIcon icon={faDeleteLeft} onClick={() => dispatch(Cases.searchCases({ searchStr: "", isWishlisted: false }))} />
			</div>
		</div>
	);
}

export default SearchCases;
